import React from 'react';
import { Alert } from 'components/Alert/Alert';
import { CheckCircle, Error } from '@mui/icons-material';
import { useDeviceType } from 'contexts/ThemeContext/hooks/useDeviceType';
import {
  ASSESSMENTS_OFFLINE_ALERT_DURATION_MS,
  ASSESSMENTS_OFFLINE_ALERT_MESSAGE,
  ASSESSMENTS_ONLINE_ALERT_MESSAGE,
} from 'features/assessments/constants';

interface OfflineWithReconnectAlertProps {
  isOnline: boolean;
  showOfflineAlert: boolean;
  dismissAlert: () => void;
}

export const OfflineWithReconnectAlert: React.FC<OfflineWithReconnectAlertProps> = ({
  isOnline,
  showOfflineAlert,
  dismissAlert,
}) => {
  const { isMobile } = useDeviceType();

  const alertMessage = isOnline
    ? ASSESSMENTS_ONLINE_ALERT_MESSAGE
    : ASSESSMENTS_OFFLINE_ALERT_MESSAGE;

  const handleDismiss = () => {
    if (isOnline) {
      dismissAlert();
    }
  };

  const snackbarSx = {
    position: 'fixed',
    top: { sm: 80, md: 80, lg: 80 },
    left: 'unset',
    right: 'unset',
  };

  return (
    <Alert
      isPresented={showOfflineAlert}
      variant="filled"
      severity={isOnline ? 'success' : 'error'}
      message={alertMessage}
      anchorOrigin={{ vertical: isMobile ? 'bottom' : 'top', horizontal: 'center' }}
      icon={isOnline ? <CheckCircle /> : <Error />}
      snackbarSx={snackbarSx}
      handleDismiss={handleDismiss}
      presentationDuration={ASSESSMENTS_OFFLINE_ALERT_DURATION_MS}
    />
  );
};
